<template>
    <div class="transfer-station">
        <UserPicker @select="onUser" />
        <button :disabled="!user" v-on:click="transfer" class="transfer-btn">{{ $t("admin.transfer.button") }}</button>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import CommonComponents from "@/views/shared";
import UserPicker from "./UserPicker.vue";
import FKApi, { EssentialStation, SimpleUser } from "@/api/api";

export default Vue.extend({
    name: "TransferStation",
    components: { ...CommonComponents, UserPicker },
    props: {
        station: {
            type: Object as PropType<EssentialStation>,
            required: true,
        },
    },
    data(): {
        user: SimpleUser | null;
    } {
        return {
            user: null,
        };
    },
    methods: {
        onUser(user: SimpleUser): void {
            this.user = user;
        },
        async transfer(): Promise<void> {
            if (this.user) {
                await new FKApi().adminTransferStation(this.station.id, this.user.id);
                this.$emit("transferred", this.user);
            }
        },
    },
});
</script>

<style scoped lang="scss">
.transfer-station {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.transfer-btn {
    align-self: flex-start;
    padding: 5px 14px;
    font-size: 12px;
    font-family: var(--font-family-medium);
    color: var(--color-danger);
    background: transparent;
    border: 1px solid var(--color-danger);
    border-radius: 3px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: var(--color-danger);
        color: #fff;
    }

    &:disabled {
        color: var(--color-border);
        border-color: var(--color-border);
        background: transparent;
        cursor: not-allowed;
    }
}
</style>
